<template>
    <el-dialog class="el-dialogs" :title="title" width="400px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="130px">
            <el-form-item label="知识图谱名称：" prop="knowledgeName">
                <el-input v-model.trim="searchForm.knowledgeName" maxlength="20"
                          placeholder="请输入知识图谱名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="关联元数据模板：" label-width="130px" prop="metaId">
                <el-select v-model="searchForm.metaId" filterable style="width: 100%" placeholder="请选择关联元数据模板" clearable>
                    <el-option
                        v-for="item in metaIdList"
                        :key="item.id"
                        :label="item.basicDataName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态：" prop="knowledgeState">
                <el-switch
                        v-model="searchForm.knowledgeState"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="描述：" prop="knowledgeDescribe">
                <el-input v-model.trim="searchForm.knowledgeDescribe" maxlength="500"
                          type="textarea" :rows="5" resize="none"
                          placeholder="请输入描述(限500字)"
                          clearable></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "addChart",
    data() {
        return {
            title: '新增知识图谱模型',
            visible: false,
            searchForm: {
                id:'',
                knowledgeName: '',
                metaId:'',
                knowledgeState: '0',
                knowledgeDescribe:'',
            },
            rules: {
                knowledgeName: [
                    {required: true, message: '请输入知识图谱名称', trigger: 'blur'}
                ],
            },
            metaIdList:[],
        }
    },

    methods: {
        //type add新增 edit编辑
        init(type, row) {
            this.searchForm.id = ''
            this.getOtherData()
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            if (type == 'add'){
                this.title = '新增知识图谱模型'
            }
            if (type == 'edit'){
                this.title = '编辑知识图谱模型'
                this.getDetail(row.id)
            }
        },

        //获取详情
        getDetail(id){
            this.$axios(this.api.academic.knowledgegraphGetById + id).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key=>{
                        this.searchForm[key] = data.data[key]
                    })
                }
            })
        },

        getOtherData(){
            this.$axios(this.api.metadata.selectMetadataBasicDataCleanList,[],'post').then(data => {
                if (data && data.status) {
                    this.metaIdList = data.data
                }
            })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.knowledgegraphUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.knowledgegraphSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>